import { OC } from "../../utils";
import { ClientAgency } from "./schema";

export const agencyContract = OC.router({
  get: OC.input(ClientAgency.Get).output(ClientAgency.Agency),
});
